import { render, staticRenderFns } from "./TravelDetail.vue?vue&type=template&id=c59b0928&"
import script from "./TravelDetail.vue?vue&type=script&lang=ts&"
export * from "./TravelDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TravelDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports